﻿window.info_meters_to_ti_edit = function () {
    var instance = {
        init: function () {

            im_decimal.mask(".decimalkvmask");
            im_integer.mask(".integermask");
        }
    };
    var im_decimal = Inputmask("decimal", {
        inputtype: "text",
        radixPoint: ',',
        digits: 7,
        rightAlign: false,
        allowMinus: false
    });
    var im_integer = Inputmask({
        mask: '9',
        placeholder: "",
        repeat: '*',
        allowMinus: false
    });
    return instance;
}();
